import { NavLink, useNavigate } from "react-router-dom";
import useCartContext from "../../hooks/useCartContext";
import useWishlistContext from "../../hooks/useWishlistContext";
import useApi from "../../hooks/useApi";
import useIsInWishlist from "../../hooks/useIsInWishlist";
import GiftCard from "./shared/GiftCard";
import Loader from "../Ui/Loader";
import InfoMessage from "../Ui/InfoMessage";
import "./Design/index.css";

const HomeGiftCardsSection = ({ title, collection }) => {
  const isTrendingSection = collection === "" || collection === "newArrival";

  const navigate = useNavigate();

  const { addToCart } = useCartContext();
  const { wishlist, addToWishlist, removeFromWishlist } = useWishlistContext();

  const {
    data: gifts,
    isPending: areGiftsPending,
    error: giftsError,
  } = useApi(
    isTrendingSection
      ? "/getBitaqtyGifts"
      : `/getGiftsByCollection/${collection}`
  );

  const { data: giftsWithWishListButton } = useIsInWishlist(gifts, wishlist);

  return (
    <>
      <section className="gift-card" id="gift-card">
        <div className="container modified_container">
          <div className="row">
            <div
              className="title title-2"
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              <h2 className="position-relative">{title}</h2>
            </div>
          </div>
          <div className="row justify-content-center ">
            <div className="binance-gift-cards">
              {areGiftsPending ? (
                <Loader />
              ) : giftsError ? (
                <InfoMessage text={giftsError} />
              ) : !giftsWithWishListButton?.length ? (
                <InfoMessage text="No gifts to show" />
              ) : (
                giftsWithWishListButton
                  ?.slice(0, isTrendingSection ? 6 : 3)
                  .map((data) => {
                    return (
                      <GiftCard
                        key={data?._id}
                        image={data?.image}
                        inbuildImage={data?.productDetails?.image}
                        title={data?.productDetails?.nameEn}
                        category={data?.productDetails?.categoryNameEn}
                        price={`${data?.productDetails?.costPriceAfterVat.toFixed(
                          2
                        )}`}
                        onClick={() => navigate(`gifts/bitaqaty/${data?._id}`)}
                        addToCart={() => addToCart(data?._id)}
                        addToWishlist={() => addToWishlist(data._id)}
                        removeFromWishlist={() => removeFromWishlist(data._id)}
                        isInWishlist={data?.isInWishlist}
                      />
                    );
                  })
              )}
            </div>

            <NavLink
              to="/search?q="
              type="submit"
              className="btn btn-primary shopBtn"
              data-aos="zoom-out-up"
              data-aos-duration="1000"
            >
              <span>{isTrendingSection ? "Shop Now" : "View All"}</span>
            </NavLink>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeGiftCardsSection;
